import { Radio } from "antd";
import { AppstoreOutlined, UnorderedListOutlined } from "@ant-design/icons";

interface IProps {
  mostrarTabla: boolean;
  alCambiar: (mostrarTabla: boolean) => void;
}

/**
 * Tabla o tarjetas, con los dos iconos de siempre: la lista para la tabla y
 * la cuadrícula para las tarjetas.
 *
 * Antes era un botón con texto que nombraba la vista a la que lleva, no la
 * que se está viendo, así que había que leerlo y deducir dónde estaba uno.
 * Con las dos opciones juntas se ve cuál está activa.
 *
 * Un icono solo no le dice nada a quien no ve la pantalla, así que cada uno
 * lleva su nombre, que sirve también para el globo del cursor.
 */
export const AlternadorVista = ({ mostrarTabla, alCambiar }: IProps) => (
  <div className="modern-view-toggle-wrapper">
    <Radio.Group
      className="modern-view-toggle-group"
      value={mostrarTabla ? "tabla" : "tarjetas"}
      onChange={(e) => alCambiar(e.target.value === "tabla")}
      buttonStyle="solid"
    >
      <Radio.Button value="tabla" aria-label="Mostrar en tabla">
        <span title="Mostrar en tabla" className="toggle-btn-content">
          <UnorderedListOutlined className="toggle-btn-icon" />
          <span className="toggle-btn-text">Tabla</span>
        </span>
      </Radio.Button>
      <Radio.Button value="tarjetas" aria-label="Mostrar en tarjetas">
        <span title="Mostrar en tarjetas" className="toggle-btn-content">
          <AppstoreOutlined className="toggle-btn-icon" />
          <span className="toggle-btn-text">Tarjetas</span>
        </span>
      </Radio.Button>
    </Radio.Group>
  </div>
);
